import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import getMaterie from "../../services/getMaterie";
import updateMateria from "../../services/updateMateria";

export default class EditMateria extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.section = this.props.section;
		if (this.section == undefined) {
			const pathname = props.location.pathname;
			this.section = pathname.substring(8, pathname.length);
		}

		this.pageName = props.pageName;
		if (this.pageName == undefined) {
			this.pageName = this.section;
		}

		this.state = {
			nome: "",
			note: "",
			isLoading: false,
		};
	}

	async componentDidMount() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });
		const currentMateria = cookies.get("currentMateria", { path: "/" });

		const materie = await getMaterie(username, token);

		const materia = materie.find(m => m.id == currentMateria);

		this.setState({
			nome: materia.materia,
			note: materia.note,
		});
	}

	render() {
		return (
			<div>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle title={"Modifica materia"} />

					<TextInput
						name={"Nome"}
						value={this.state.nome}
						onChange={text => {
							this.setState({ nome: text });
						}}
					/>

					<TextInput
						name={"Note"}
						value={this.state.note}
						onChange={text => {
							this.setState({ note: text });
						}}
					/>

					<FixButton title={"Salva"} callback={this.save.bind(this)} />
				</LoadingOverlay>
			</div>
		);
	}

	async save() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });
		const currentMateria = cookies.get("currentMateria", { path: "/" });

		await updateMateria(username, token, currentMateria, this.state.nome, this.state.note);

		window.location.href = "/#/app/materie";
	}
}
